import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
const projects = [{
  title: 'BrightLocal',
  subtitle: 'AI replies and onboarding',
  description: 'Redesigned the user onboarding experience and implemented AI-powered response system that increased user activation by 32%.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1hG1wLngHSmo9UU4s47BTe/brightlocal_engraved_transparent_v4.png',
  width: 140,
  height: 64
}, {
  title: 'MOO',
  subtitle: 'Checkout and identity',
  description: 'Streamlined the checkout process and created a cohesive brand identity system, resulting in a 24% increase in conversion rate.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ndqUZaEks1sPkYJTL6hWLK/moo_engraved_transparent.png',
  width: 120,
  height: 64
}, {
  title: 'Tesco',
  subtitle: 'Data platform and monitoring',
  description: 'Developed a comprehensive data platform and monitoring system that improved operational efficiency by 40%.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6p5KuHtKZ5oAo4SJKkAgGF/tesco_engraved_transparent.png',
  width: 120,
  height: 64
}, {
  title: 'Digikala',
  subtitle: 'Shopping experience',
  description: 'Revamped the entire shopping experience with a focus on personalization, leading to a 28% increase in average order value.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ejCtjx1Qji7ShyJy9tEoST/digikala_engraved_transparent.png',
  width: 130,
  height: 64
}];
export function SelectedWork() {
  const [showTooltip, setShowTooltip] = useState(false);
  return <section id="work" className="py-28 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-237">
      {/* Decorative elements */}
      <div className="absolute top-60 left-20 w-32 h-px bg-ink-300 opacity-30" data-id="element-238"></div>
      <div className="absolute top-64 left-40 w-16 h-px bg-ink-300 opacity-30" data-id="element-239"></div>
      <div className="absolute bottom-60 right-20 w-32 h-px bg-ink-300 opacity-30" data-id="element-240"></div>
      <div className="absolute bottom-64 right-40 w-16 h-px bg-ink-300 opacity-30" data-id="element-241"></div>
      <div className="container mx-auto max-w-5xl" data-id="element-242">
        <motion.div className="mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-243">
          <div className="relative inline-block" data-id="element-244">
            <h2 className="text-3xl font-currency italic tracking-wide mb-5 currency-heading" data-id="element-245">
              Selected Work
            </h2>
            <div className="absolute -right-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-246"></div>
            <div className="absolute -left-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-247"></div>
          </div>
          <div className="h-px w-16 bg-ink-900 mb-10" data-id="element-248"></div>
          <p className="text-ink-600 max-w-2xl font-serif" data-id="element-249">
            A showcase of projects where I've helped teams navigate complexity
            and deliver exceptional products.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-16 mb-20" data-id="element-250">
          {projects.map((project, index) => <motion.div key={index} className="relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-251">
              {/* Decorative corner element */}
              <div className="absolute -top-3 -left-3 w-6 h-6" data-id="element-252">
                <div className="absolute top-0 left-0 w-6 h-px bg-ink-400" data-id="element-253"></div>
                <div className="absolute top-0 left-0 h-6 w-px bg-ink-400" data-id="element-254"></div>
              </div>
              <div className="flex items-start mb-5" data-id="element-255">
                <div className="flex-1" data-id="element-256">
                  <h3 className="text-2xl font-currency tracking-wide mb-2" data-id="element-257">
                    {project.title}
                  </h3>
                  <p className="text-ink-700 text-sm uppercase tracking-wider mb-5 font-mono" data-id="element-258">
                    {project.subtitle}
                  </p>
                  <div className="h-px w-12 bg-ink-200 mb-5" data-id="element-259"></div>
                </div>
                <div className="ml-4 flex-shrink-0" data-id="element-260">
                  <picture data-id="element-261">
                    <img src={project.image} alt={`${project.title} logo`} className="h-16 w-auto object-contain opacity-90" width={project.width} height={project.height} data-id="element-262" />
                  </picture>
                </div>
              </div>
              <p className="text-ink-600 font-serif" data-id="element-263">{project.description}</p>
            </motion.div>)}
        </div>
        <div className="flex justify-center" data-id="element-264">
          <div className="relative" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} data-id="element-265">
            <Button data-id="element-266">View case studies</Button>
            {showTooltip && <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-ink-900 text-white text-xs py-1 px-3 rounded font-serif whitespace-nowrap" data-id="element-267">
                Coming soon
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-ink-900" data-id="element-268"></div>
              </div>}
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto mt-32 px-6" data-id="element-269">
        <div className="h-px bg-ink-200 w-full" data-id="element-270"></div>
      </div>
    </section>;
}